import React, { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Spin, message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";

const { Title } = Typography;

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token") || "";

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Blog`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setBlogs(response.data?.data || response.data || []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch blogs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <>
      <HeaderLayout />
      <div style={{ padding: 24, minHeight: "70vh" }}>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: 80 }}>
            <Spin size="large" />
          </div>
        ) : (
          <Row gutter={[24, 24]} align={"middle"} justify={"center"}>
            {blogs.map((blog) => (
              <Col xs={24} sm={12} lg={8} key={blog.id}>
                <Card
                  hoverable
                  onClick={() => navigate(`/blog/${blog.slug}`)}
                  style={{
                    borderRadius: 12,
                    overflow: "hidden",
                    height: 360,
                    cursor: "pointer",
                  }}
                  cover={
                    <img
                      alt={blog.title}
                      src={blog.coverImageUrl}
                      style={{
                        height: 220,
                        objectFit: "cover",
                      }}
                    />
                  }
                >
                  <Title level={4} style={{ marginBottom: 12 }}>
                    {blog.title}
                  </Title>

                  {/* HTML Preview */}
                  <div
                    className="blog-preview"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                  />
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
      <FooterLayout />
    </>
  );
};

export default BlogList;